export const isValidYoutubeOrVimeoVideoUrl = (value: string | undefined) => {
  if (value) {
    const youtubeRegex =
      /^(?:https?:\/\/)?(?:www\.)?(?:youtube\.com\/(?:[^\/\n\s]+\/\S+\/|(?:v|e(?:mbed)?)\/|\S*?[?&]v=)|youtu\.be\/)([a-zA-Z0-9_-]{11})/;

    const vimeoRegex =
      /^(?:https?:\/\/)?(?:www\.)?(?:vimeo\.com(?:\/video)?\/|vimeo\.com\/channels\/(?:[\w-]+\/)?)([0-9]+)/;

    const youtubeMatch = value.match(youtubeRegex);
    const vimeoMatch = value.match(vimeoRegex);

    return youtubeMatch || vimeoMatch;
  }

  return false;
};
